import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_routing_overview_return",
  ref: "orderRoutingReturnRefundModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_routing_overview_return_header"
}
const _hoisted_5 = { class: "w-100 d-flex align-items-center justify-content-between" }
const _hoisted_6 = { class: "fw-bolder" }
const _hoisted_7 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "modal-body p-10" }
const _hoisted_11 = { class: "bg-light-primary rounded border-primary border border-dashed d-flex align-items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"148px"},
    src: "media/images/logistic.png",
    alt: "",
    title: ""
  })
], -1)
const _hoisted_13 = { class: "p-8" }
const _hoisted_14 = { class: "mt-10" }
const _hoisted_15 = { class: "modal-footer flex-right" }
const _hoisted_16 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "indicator-label" }
const _hoisted_19 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_20 = { class: "indicator-progress" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.t("orderRefund.returnRefund")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.t("orderRefund.returnRefundModalTips")), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.isChecked,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isChecked) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("orderRefund.returnRefundModalCheckLabel")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              type: "button",
              class: "btn btn-light me-3",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.modalHide && _ctx.modalHide(...args)))
            }, [
              _createElementVNode("span", _hoisted_16, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.cancel")), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-lg btn-primary",
              disabled: !_ctx.isChecked,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onContinueButtonClick && _ctx.onContinueButtonClick(...args)))
            }, [
              _createElementVNode("span", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.continue")), 1)
              ]),
              _createElementVNode("span", _hoisted_20, [
                _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                _hoisted_21
              ])
            ], 8, _hoisted_17)
          ])
        ])
      ])
    ])
  ], 512))
}